import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Table } from 'react-bootstrap';
import _ from 'underscore';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';

import { PENDING } from '../../../constants/JobStatus';

class DriverJobsModal extends Component {
  getTitle() {
    const { type, name, t } = this.props;

    if (type === PENDING) {
      return t('OFFERS_FOR_NAME', { name });
    }
    return t('JOBS_FOR_NAME', { name });
  }
  renderJobItems() {
    const { jobs = [], t } = this.props;
    if (!jobs || jobs.length === 0) {
      return (
        <tr>
          <td colSpan={4}>{t('THERE_ARE_NO_JOBS')}</td>
        </tr>
      );
    }
    return jobs.map((job, i) => {
      const jobDetaiLink = `/shipments/${job._id}`;
      let originName = '';
      let destinationName = '';

      if (job.origin && job.origin.length > 0) {
        originName = job.origin[0].name;
      }

      if (job.destination && job.destination.length > 0) {
        destinationName = job.destination[0].name;
      }
      const flatTimeline = Object.values(job.timeline);
      const currentStatus = _.last(_.sortBy(flatTimeline, (e) => e.status.code))
        .status.message;
      return (
        <tr key={i}>
          <td>
            <a href={jobDetaiLink}>{job.shipment_id}</a>
          </td>
          <td>
            <span>{originName}</span>
          </td>
          <td>
            <span>{destinationName}</span>
          </td>
          <td>
            <span>{currentStatus}</span>
          </td>
        </tr>
      );
    });
  }
  render() {
    const { t } = this.props;
    return (
      <Modal show={this.props.isOpen}>
        <Modal.Header closeButton>
          <Modal.Title>{this.getTitle()}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table condensed striped hover className="driver-jobs-table">
            <thead>
              <tr>
                <th>{titleize(t('SHIPMENT'))} #</th>
                <th>{titleize(t('ORIGIN'))}</th>
                <th>{titleize(t('DESTINATION'))}</th>
                <th>{t('STATUS')}</th>
              </tr>
            </thead>
            <tbody>{this.renderJobItems()}</tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => this.props.onClose()}>Close</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

DriverJobsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  name: PropTypes.string,
  jobs: PropTypes.array,
  type: PropTypes.string.isRequired,
};

DriverJobsModal.defaultProps = {
  name: '',
  jobs: [],
};
export default withTranslation()(DriverJobsModal);
